import React from 'react';
// import Layout from '../components/Layout'; // Removido para página independente

function Suporte() {
  return (
    <div className="suporte-page">
      <div className="container">
        <div className="section-header">
          <h1>Suporte ao Cliente</h1>
          <p>Estamos aqui para ajudar você! Entre em contato conosco através dos canais abaixo.</p>
        </div>

        <div className="suporte-content">
          <div className="suporte-grid">
            <div className="suporte-card">
              <div className="card-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3>Telefone</h3>
              <a href="tel:+5522999611338" className="contact-link">
                (22) 99961-1338
              </a>
              <a 
                href="https://wa.me/5522999611338" 
                target="_blank" 
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
            </div>

            <div className="suporte-card">
              <div className="card-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>E-mail</h3>
              <a href="mailto:suporte@unetbandalarga.com.br" className="contact-link">
                suporte@unetbandalarga.com.br
              </a>
            </div>

            <div className="suporte-card">
              <div className="card-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Endereço</h3>
              <p className="text-gray-600 mb-4">Atendimento presencial</p>
              <p className="contact-info">
                Rua Engenheiro Luiz Carlos Gomes Carvalho, 211<br />
                Ururai - Campos dos Goytacazes<br />
                Rio de Janeiro - RJ
              </p>
            </div>

            <div className="suporte-card">
              <div className="card-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3>Horário de Atendimento</h3>
              <p className="text-gray-600 mb-4">Suporte técnico</p>
              <div className="contact-info">
                <p><strong>Presencial:</strong><br />
                Segunda a Sábado: 08:00 - 17:00</p>
                <p><strong>Telefone/WhatsApp:</strong><br />
                Segunda a Sexta: 08:00 - 19:00<br />
                Sábados: 08:00 - 17:00<br />
                Domingos e Feriados: 08:00 - 11:00</p>
              </div>
            </div>
          </div>

          <div className="faq-section">
            <h2>Perguntas Frequentes</h2>
            
            <div className="faq-item">
              <h3>Como funciona o suporte técnico?</h3>
              <p>Nosso suporte técnico é gratuito e está disponível 24/7 para emergências. Para problemas simples, nossa equipe pode resolver remotamente. Para casos mais complexos, agendamos uma visita técnica.</p>
            </div>

            <div className="faq-item">
              <h3>Como posso verificar minha velocidade de internet?</h3>
              <p>Você pode acessar nossa Central do Assinante e fazer um teste de velocidade, ou entrar em contato conosco para agendar uma verificação técnica.</p>
            </div>

            <div className="faq-item">
              <h3>O que fazer se minha internet cair?</h3>
              <p>Primeiro, verifique se há problemas com seu roteador. Se o problema persistir, entre em contato conosco pelo telefone ou WhatsApp para suporte imediato.</p>
            </div>

            <div className="faq-item">
              <h3>Como alterar meu plano?</h3>
              <p>Entre em contato conosco pelo telefone, WhatsApp ou e-mail. Nossa equipe irá orientá-lo sobre as opções disponíveis e fazer a alteração do seu plano.</p>
            </div>

            <div className="faq-item">
              <h3>Como acessar minha Central do Assinante?</h3>
              <p>Você pode acessar sua Central do Assinante através do menu principal do site ou diretamente pelo link "Central do Assinante". Lá você pode visualizar faturas, fazer pagamentos, solicitar suporte e gerenciar seus serviços.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Suporte; 